import { defineMessages } from 'react-intl';

export const voucherTypesMessages = defineMessages({
    voucherTypes: {
        id: 'voucher-types',
        defaultMessage: 'Voucher types',
    },
    voucherType: {
        id: 'voucher-type',
        defaultMessage: 'Voucher type',
    },
    voucher: {
        id: 'voucher',
        defaultMessage: 'Voucher',
    },
    vouchers: {
        id: 'vouchers',
        defaultMessage: 'Vouchers',
    },
    code: {
        id: 'code',
        defaultMessage: 'Code',
    },
    isActive: {
        id: 'is-active',
        defaultMessage: 'Is active',
    },
    usage: {
        id: 'usage',
        defaultMessage: 'Usage',
    },
    single: {
        id: 'single',
        defaultMessage: 'Single',
    },
    balance: {
        id: 'balance',
        defaultMessage: 'Balance',
    },
    maxCount: {
        id: 'max-count',
        defaultMessage: 'Max count',
    },
    createVoucherTypeSuccess: {
        id: 'create-voucher-type-success',
        defaultMessage: 'Voucher type created',
    },
    createVoucherTypeSuccessDescription: {
        id: 'create-voucher-type-success-description',
        defaultMessage: 'The voucher type has been successfully created.',
    },
    addVoucherTypeSubtitle: {
        id: 'add-voucher-type-subtitle',
        defaultMessage: 'Create a new voucher type',
    },
    deleteVoucherType: {
        id: 'delete-voucher-type',
        defaultMessage: 'Delete voucher type',
    },
    deleteVoucherTypeSuccess: {
        id: 'delete-voucher-type-success',
        defaultMessage: 'Voucher type deleted',
    },
    deleteVoucherTypeSuccessDescription: {
        id: 'delete-voucher-type-success-description',
        defaultMessage: 'The voucher type has been successfully deleted.',
    },
    confirmDeleteVoucherType: {
        id: 'confirm-delete-voucher-type',
        defaultMessage: 'Are you sure you want to delete this voucher type? This action cannot be undone.',
    },
    deleteVoucherTypeSubtitle: {
        id: 'delete-voucher-type-subtitle',
        defaultMessage: 'Permanently delete voucher type {name}',
    },
    backToAllVoucherTypes: {
        id: 'back-to-all-voucher-types',
        defaultMessage: 'Back to all voucher types',
    },
    voucherTypeDashboard: {
        id: 'voucher-type-dashboard',
        defaultMessage: 'Voucher type dashboard',
    },
    editVoucherTypeSubtitle: {
        id: 'edit-voucher-type-subtitle',
        defaultMessage: 'Edit voucher type',
    },
    updateVoucherTypeSuccess: {
        id: 'update-voucher-type-success',
        defaultMessage: 'Voucher type updated',
    },
    updateVoucherTypeSuccessDescription: {
        id: 'update-voucher-type-success-description',
        defaultMessage: 'The voucher type has been successfully updated.',
    },
    alreadyIssuedWarning: {
        id: 'voucher-type-already-issued-warning',
        defaultMessage:
            '{count, plural, one {# voucher has} other {# vouchers have}} already been issued from this type. Changing the amount, percent or usage will not affect {count, plural, one {it} other {them}} — issued vouchers keep the name and value they were issued with.',
    },
    voucherTypesTableBadge: {
        id: 'voucher-types-table-badge',
        defaultMessage: 'Voucher types',
    },
    voucherTypeTableBadge: {
        id: 'voucher-type-table-badge',
        defaultMessage: 'Voucher type',
    },
});
